<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { CLASS_ROOT } from '../constants'

const { t } = useI18n()

// Flag whether the gestor is active (opened) and shows additional text.
const active = ref<boolean>(false)
</script>

<template>
  <div
    :class="[
      `${CLASS_ROOT}__brand-gestor`,
      {
        [`${CLASS_ROOT}__brand-gestor`]: active,
      },
    ]"
  >
    <span :class="`govuk-body-s ${CLASS_ROOT}__brand-gestor-text`">
      {{ t('gestor-text.official-website') }}
      <IDSKHeaderGestorButton
        v-model="active"
        data-test-id="button-gestor-verejna-sprava"
      >
        {{ t('gestor-text.public-administration') }}
      </IDSKHeaderGestorButton>
    </span>
    <span :class="`govuk-body-s ${CLASS_ROOT}__brand-gestor-text--mobile`">
      SK
      <IDSKHeaderGestorButton v-model="active" data-test-id="button-gestor-egov">
        e-gov
      </IDSKHeaderGestorButton>
    </span>

    <div
      v-if="active"
      :class="[
        `${CLASS_ROOT}__brand-dropdown`,
        {
          [`${CLASS_ROOT}__brand-dropdown--active`]: active,
        },
      ]"
    >
      <IDSKContainer>
        <IDSKRow>
          <IDSKCol variant="one-half">
            <h3 :class="`govuk-body-s`">{{ t('domain.headline') }}</h3>
            <p :class="`govuk-body-s`">
              {{ t('domain.text') }}
              <a
                :class="`govuk-link`"
                href="https://www.slovensko.sk/sk/agendy/agenda/_organy-verejnej-moci"
                target="_blank"
                :title="t('domain.link.title')"
                >{{ t('domain.link.text') }}</a
              >.
            </p>
          </IDSKCol>
          <IDSKCol variant="one-half">
            <h3 :class="`govuk-body-s`">{{ t('secured.headline') }}</h3>
            <p :class="`govuk-body-s`">
              {{ t('secured.text') }}
            </p>
          </IDSKCol>
        </IDSKRow>
      </IDSKContainer>
    </div>
  </div>
  <div
    :class="[
      `${CLASS_ROOT}__brand-spacer`,
      {
        [`${CLASS_ROOT}__brand-spacer--active`]: active,
      },
    ]"
  ></div>
</template>

<i18n lang="yaml">
sk:
  gestor-text:
    official-website: 'Oficiálna stránka'
    public-administration: 'verejnej správy SR'
  domain:
    headline: 'Doména gov.sk je oficiálna'
    text: 'Toto je oficiálna webová stránka orgánu verejnej moci Slovenskej republiky. Oficiálne stránky využívajú najmä doménu gov.sk.'
    link:
      text: 'Odkazy na jednotlivé webové sídla orgánov verejnej moci nájdete na tomto odkaze'
      title: 'odkazy na webové sídla orgánov verejnej moci'
  secured:
    headline: 'Táto stránka je zabezpečená'
    text: 'Buďte pozorní a vždy sa uistite, že zdieľate informácie iba cez zabezpečenú
              webovú stránku verejnej správy SR. Zabezpečená stránka vždy začína https://
              pred názvom domény webového sídla.'
</i18n>
